export const PendingDepositIcon: React.FC<React.SVGAttributes<{}>> = (
  props
) => {
  return (
    <svg fill="none" viewBox="0 0 22 22" {...props}>
      <path
        d="M11 1.83325V7.33325L12.8333 5.49992"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 7.33333L9.16663 5.5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41667 11C2.75 11 2.75 12.6408 2.75 14.6667V15.5833C2.75 18.1133 2.75 20.1667 7.33333 20.1667H14.6667C18.3333 20.1667 19.25 18.1133 19.25 15.5833V14.6667C19.25 12.6408 19.25 11 15.5833 11C14.6667 11 14.41 11.1925 13.9333 11.55L12.9983 12.54C11.9167 13.695 10.0833 13.695 8.9925 12.54L8.06667 11.55C7.59 11.1925 7.33333 11 6.41667 11Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58337 11V7.33337C4.58337 5.49087 4.58337 3.9692 7.33337 3.70337"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4166 11V7.33337C17.4166 5.49087 17.4166 3.9692 14.6666 3.70337"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
